export const TX_DELEGATION_TRANSFER_AMOUNT_SET =
  "TX_DELEGATION_TRANSFER_AMOUNT_SET";
export const TX_DELEGATION_TRANSFER_LIST = "TX_DELEGATION_TRANSFER_LIST";
export const TX_DELEGATION_TRANSFER_ADDRESS_SET =
  "TX_DELEGATION_TRANSFER_ADDRESS_SET";
export const TX_DELEGATION_TRANSFER_MEMO_SET =
  "TX_DELEGATION_TRANSFER_MEMO_SET";
export const TX_DELEGATION_TRANSFER_MODAL = "TX_DELEGATION_TRANSFER_MODAL";
export const TX_DELEGATION_TOKENIZE_MODAL = "TX_DELEGATION_TOKENIZE_MODAL";
